import React from 'react';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';

const ConversationSkeleton = () => {
    const { isDarkMode } = useTheme();

    const themeColors = {
        background: isDarkMode ? '#1f1f1f' : '#fff',
        border: isDarkMode ? '#303030' : '#f0f0f0',
        skeletonColor: isDarkMode ? 'rgba(255, 255, 255, 0.08)' : '#f5f5f5'
    };

    return (
        <div style={{
            padding: '8px 16px',
            borderBottom: `1px solid ${themeColors.border}`,
            display: 'flex',
            alignItems: 'flex-start',
            background: themeColors.background,
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            overflow: 'hidden'
        }}>
            {/* Avatar with status badge */}
            <div style={{ position: 'relative', marginRight: '12px', flexShrink: 0 }}>
                <div style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '50%',
                    backgroundColor: themeColors.skeletonColor
                }}></div>
                <div style={{
                    position: 'absolute',
                    right: '0',
                    bottom: '0',
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: themeColors.skeletonColor
                }}></div>
            </div>

            {/* Content */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px', minWidth: 0, overflow: 'hidden' }}>
                {/* Title and time row */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{
                        width: '80px',
                        height: '14px',
                        backgroundColor: themeColors.skeletonColor,
                        borderRadius: '4px'
                    }}></div>
                    <div style={{
                        width: '20px',
                        height: '12px',
                        backgroundColor: themeColors.skeletonColor,
                        borderRadius: '4px'
                    }}></div>
                </div>

                {/* Message preview */}
                <div style={{
                    width: '140px',
                    height: '14px',
                    backgroundColor: themeColors.skeletonColor,
                    borderRadius: '4px'
                }}></div>
            </div>
        </div>
    );
};

export default ConversationSkeleton;
